export default __webpack_public_path__ + "static/media/bg_cta.3355deaf.jpg";